import { render, staticRenderFns } from "./PauseNotificationModal.vue?vue&type=template&id=6652c94c&"
import script from "./PauseNotificationModal.vue?vue&type=script&lang=js&"
export * from "./PauseNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports